import i18next from 'i18next';
import type { FilterType } from '@hotjar/global-filters';
import { getGlobalFiltersLabel } from '@hotjar/global-filters';

export const getSeriesLabel = (filterList: FilterType[]): string => {
  const result = getGlobalFiltersLabel(filterList);
  return result || i18next.t('dashboard-quantz:allSessions');
};
